// extracted by mini-css-extract-plugin
export default {"compareContent":"Q7fRqbxtJd","compareTitle":"gPBmRYJVOb","compareSubTitle":"wS4AUZRUKw","disclaimerTrigger":"a05u5JZPQx","disclaimerTooltip":"DJNY2YZYSt"};